// ENUMS --------------------
export enum Direction {
  outbound = 'OUTBOUND',
  inbound = 'INBOUND',
}

export enum SpeakingWithType {
  member = 'MEMBER',
  contact = 'CONTACT',
  provider = 'PROVIDER',
  insurance = 'INSURANCE',
  resource = 'RESOURCE',
  facility = 'FACILITY',
  other = 'OTHER',
}
